"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const c = (l) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.59 4.849H5.41C3.527 4.849 2 6.329 2 8.155v6.934c-.008.882.348 1.73.988 2.357.64.626 1.512.979 2.422.979h13.18c.91 0 1.782-.353 2.422-.979.64-.627.996-1.475.988-2.357V8.155c0-1.826-1.527-3.306-3.41-3.306M12 7.35c1.31 0 2.372 1.025 2.38 2.295.007 1.27-1.045 2.307-2.354 2.321s-2.384-1-2.406-2.27a2.28 2.28 0 0 1 .686-1.654A2.43 2.43 0 0 1 12 7.351Zm3.8 9.377c.26 0 .47-.204.47-.455v-1.31a2.03 2.03 0 0 0-.617-1.46 2.15 2.15 0 0 0-1.503-.606h-4.3c-.564 0-1.105.218-1.503.606s-.62.913-.617 1.46v1.31c0 .251.21.455.47.455z",
        clipRule: "evenodd"
      }
    )
  }
), m = e(c);
export {
  m as CardFilled,
  m as default
};
